import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom';
import EnterToSystemSection from './components/WelcomeSections/EnterToSystemSection/EnterToSystemSection'
import EliteServersSection from './components/WelcomeSections/EliteServersSection/EliteServersSection'
import OurServicesSection from './components/WelcomeSections/OurServicesSection/OurServicesSection'
import { useAuth } from 'contexts/AuthContext'

const WelcomePage = () => {
    const navigate = useNavigate();
    const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
    const { fetchProfile } = useAuth();
    const [searchParams] = useSearchParams();

    // Deep linking: /?view=about  or  /?service=servers
    useEffect(() => {
        const viewParam = searchParams.get('view');
        const serviceParam = searchParams.get('service');

        if (serviceParam) {
            navigate('/services/' + serviceParam, { replace: true });
        } else if (viewParam) {
            if (['about', 'contacts', 'privacy', 'profile', 'ai', 'speedtest'].includes(viewParam)) {
                navigate('/' + viewParam, { replace: true });
            }
        }
    }, [searchParams, navigate]);

    // Обработка Google OAuth redirect
    useEffect(() => {
        const hash = window.location.hash;
        if (hash && hash.includes('access_token')) {
            setGoogleAuthLoading(true);
            const params = new URLSearchParams(hash.substring(1));
            const accessToken = params.get('access_token');

            if (accessToken) {
                fetch('https://security.ncore.kg/api/account/google/callback/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ access_token: accessToken })
                })
                    .then(async res => {
                        const data = await res.json();
                        if (!res.ok) throw new Error(data.error || 'Ошибка авторизации');
                        return data;
                    })
                    .then(async data => {
                        if (data.access && data.refresh && data.user) {
                            localStorage.setItem('token', data.access);
                            localStorage.setItem('access_token', data.access);
                            localStorage.setItem('refresh_token', data.refresh);
                            localStorage.setItem('auth_user', JSON.stringify(data.user));

                            window.history.replaceState(null, '', window.location.pathname);

                            try {
                                await fetchProfile(data.access);
                                window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: data.user }));
                                setTimeout(() => {
                                    window.dispatchEvent(new CustomEvent('refreshProfile'));
                                }, 100);
                            } catch (profileErr) {
                                // Non-critical, data already in localStorage
                            }

                            setGoogleAuthLoading(false);
                        } else {
                            throw new Error('Некорректный ответ сервера: отсутствуют необходимые данные');
                        }
                    })
                    .catch(err => {
                        setGoogleAuthLoading(false);
                        window.history.replaceState(null, '', window.location.pathname);
                        const errorMessage = err.message || 'Неизвестная ошибка';
                        if (!errorMessage.includes('fetch') && !errorMessage.includes('NetworkError')) {
                            alert('Ошибка авторизации через Google:\n' + errorMessage);
                        }
                    });
            }
        }
    }, [fetchProfile]);

    return (
        <>
            {googleAuthLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    color: 'white',
                    fontSize: '24px',
                    fontWeight: '600',
                    flexDirection: 'column',
                    gap: '20px'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        border: '4px solid rgba(255, 255, 255, 0.2)',
                        borderTopColor: '#fff',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite'
                    }}></div>
                    <div>Авторизация через Google...</div>
                </div>
            )}
            <EnterToSystemSection />
            <EliteServersSection />
            <OurServicesSection onOpenService={(id) => navigate('/services/' + id)} />
        </>
    );
};

export default WelcomePage;

